import { cn } from '@/lib/cn'
import { UtensilsCrossed } from 'lucide-react'
import { useState } from 'react'
import { CuisineAccent } from './CuisineAccent'

/**
 * A recipe's photo, or a cuisine-tinted placeholder of the same size when it
 * has none, so cards with and without photos line up.
 */
export function RecipeCover({
  imageUrl,
  cuisine,
  className,
  iconSize = 28,
}: {
  imageUrl: string | null
  cuisine: string | null
  className?: string
  iconSize?: number
}) {
  // A photo that fails to load falls back to the placeholder, not a broken icon.
  const [failed, setFailed] = useState<string | null>(null)
  const showImage = imageUrl !== null && failed !== imageUrl
  return (
    <div className={cn('relative overflow-hidden', className)}>
      {showImage ? (
        <img
          src={imageUrl}
          alt=""
          loading="lazy"
          onError={() => setFailed(imageUrl)}
          className="size-full object-cover"
        />
      ) : (
        <>
          <CuisineAccent cuisine={cuisine} className="absolute inset-0" />
          <span className="absolute inset-0 grid place-items-center text-ink opacity-15">
            <UtensilsCrossed size={iconSize} strokeWidth={1.5} aria-hidden />
          </span>
        </>
      )}
    </div>
  )
}
